import { SectionHeader, Table } from "@pentabd/ui";
import { useTranslation } from "react-i18next";
import { TableColumn } from "./TableColumn";
import { EmployeeFileInquiryResponseType } from "@type/HRM/fileInquiry";

type FileInquiryTableProps = {
  isProfileDisabled: boolean;
  employeeFileInquiry: EmployeeFileInquiryResponseType | undefined;
  fetchSingleFileInquiry: (fileInquiryId: number) => void;
  isLoading: boolean;
  handleEditMode?: (isEdit: boolean) => void;
};

export const FileInquiryTable = ({
  isProfileDisabled,
  employeeFileInquiry,
  fetchSingleFileInquiry,
  isLoading,
  handleEditMode,
}: FileInquiryTableProps) => {
  const { t } = useTranslation();

  return (
    <div className="py-10">
      <div className="pb-10">
        <SectionHeader title={t("EMPLOYEE.FILE_INQUIRY.TABLE.LABEL")} />
      </div>
      <Table
        columns={TableColumn({
          isProfileDisabled,
          fetchSingleFileInquiry,
          handleEditMode,
        })}
        rows={employeeFileInquiry?.assigneeFile || []}
        loading={isLoading}
        isStickyHeader
        height={
          (employeeFileInquiry?.assigneeFile?.length ?? 0) > 5 ? 500 : undefined
        }
      />
    </div>
  );
};
